import enIndexes from './en-content.json';

interface Path {
  url: {
    path: string;
  };
}

export const parseLangPath = (link: string): Path => {
  function isNumeric(value: string): boolean {
    return !isNaN(Number(value)) && isFinite(Number(value));
  }
  const parts = link.split('/');

  if (parts.length > 0 && parts[2] === 'node' && isNumeric(parts[3])) {
    const node = (enIndexes['en'] as { id: string; path: string }[]).filter(x => x.id === parts[3]);
    return {
      url: {
        path: node[0] ? node[0].path : link,
      },
    };
  }

  return {
    url: {
      path: link,
    },
  };
};
